import angular from 'angular';
import fbDateFieldCtrl from './fb-date-field.controller'

import FactDateishGrouping from '../../groupings/fact-dateish'
import DateParserServ from '../../services/date-parser/date-parser'

let fbDateField = {
  template: require('./fb-date-field.html'),
  bindings: {
    /* 
      Inputs
      hero: '<',    // one-way binding, changing shoudln't update parent scope
                       mutations to objects or arrays should occur in parent
      comment: '@'  // for static strings
      Outputs: & bindings, callbacks for component events
      onDelete: '&'
      onUpdate: '&'
      
      */
    fbDateish: '<',
    updateFact: '&'
  },
  controller: fbDateFieldCtrl
}

export default angular.module('components.fbDateField', [FactDateishGrouping, DateParserServ])
  .component('fbDateField', fbDateField)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-date-field/index.js